import { useEffect, useState } from "preact/hooks";
import { MappedImage, ModalWrapper } from "src/utils/fw";
import { get } from "../../utils/http";

export const CometChatIcon = ({optinUrl = "", bgcolor = "#FFDD3A"}) => <div style="position: fixed; height: 60px; right: 20px; bottom: 20px; width: 60px; z-index: 100; ">
	<MappedImage imageURL="https://widget-js.cometchat.io/v2/resources/chat_bubble.svg" imageStyle={`width: 100%; background-color:${bgcolor}; border-radius: 50%; z-index: 100; cursor: pointer; box-shadow: rgba(0, 0, 0, 0.06) 0px 1px 6px 0px, rgba(0, 0, 0, 0.16) 0px 2px 32px 0px;`}
		links={[{
			height: "100%",
			left: "0%",
			width: "100%",
			top: "0%",
			modalOverrides: {
				dismissHTML: "X",
				dismissStyle: {
					color: "#fff",
					fontSize: "25px"
				}
			},
			modal: <ModalWrapper>
				<div style="display: flex; flex-direction: column; justify-content: space-around; width: 600px; height: 130px; color: white;">
					<h1 style="font-size: 28px; margin: 0;">Want to Participate in the Networking Chat?</h1>
					<p style="font-size: 16px;">You are not opted-in to the networking chat feature. To opt-in, please modify the networking page of your registration <a style={{textDecoration: "underline"}} href={optinUrl}>here.</a>
					</p>
				</div>
			</ModalWrapper>
		}]}
	/>
</div>

export const CometChat = () => {
	const regID = window.dataLayer[0]["Registrant ID"]
	const fullName = window.dataLayer[0]["First & Last Name"]
	const company = window.dataLayer[0]['Company (Subsidiary)'];
	var userName = fullName + (company ? ` - ${company}` : "")

	const picture = window.dataLayer[0]['Please make it more personal by uploading a head and shoulders photo:'] || "https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/Linecons_user-avatar.svg/600px-Linecons_user-avatar.svg.png"
	const regUid = regID.toString()

	const [widgetLoad, setWidgetLoad] = useState(false)

	useEffect(() => {
		window.openDM = chatGuid => {
			window.CometChatWidget.openOrCloseChat(true)
			window.CometChatWidget.chatWithUser(chatGuid);
		}
	})

	useEffect(() => {
		if (widgetLoad)
			window.openChat = chatGuid => {
				window.CometChatWidget.openOrCloseChat(true)
				window.CometChatWidget.chatWithGroup(chatGuid);
			}
	}, [widgetLoad])

	const loadStage4 = () => {
		window.CometChatWidget.launch({
			alignment: "right",
			docked: "true",
			height: "550px",
			// left or right
			roundedCorners: "true",
			widgetID: "8a02250d-db56-4bcb-a97e-08626d81c910",
			width: "400px",
		}).then(() => {
			setWidgetLoad(true)
		})
		if (window.dataLayer[0]["Member and Non Member Reg Type"] === "Non-Member") {
			get(`https://isf2021.swoogo-retrofit.tkevents.io/chat/addToNonMemberChats`, { id: regUid })
		} else {
			get(`https://isf2021.swoogo-retrofit.tkevents.io/chat/addToMemberChats`, { id: regUid })
		}

		
	}

	const loadStage3 = () => {
		// You can now call login function.
		window.CometChatWidget.login({
			uid: regUid,
		}).then(loadStage4)
	}

	const loadStage2 = () => {
		window.CometChatWidget.createOrUpdateUser({
			avatar: picture,
			name: userName,
			uid: regUid,
		}).then(loadStage3)
	}

	const loadStage1 = async () => {
		const regType = window.dataLayer[0]["Member and Non Member Reg Type"] === "Non-Member" ? "nmember" : "member"
		const resp = await fetch(`https://backend.swoogo-retrofit.tkevents.io/cc/getToken/${regType}`)
		const data = await resp.json()
		
		window.CometChatWidget.init(data).then(loadStage2)
	}

	const bootChatIfReady = () => {
		if (window.CometChatWidget === undefined) {
			setTimeout(bootChatIfReady, 250)
		} else { loadStage1() }
	}

	if (!widgetLoad) bootChatIfReady()

	return <script defer src="https://widget-js.cometchat.io/v3/cometchatwidget.js" />
}

window.openChat = false